import styled, { css } from 'styled-components';
import { breakPointDistance } from '../../../foundation/theme/breakpoints.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
import { UI_SIZES } from '../../../foundation/theme/theme.types';
import { AS_RULES, EDITORIAL_RULES, SIZES_RULES } from './Header.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const HeaderRoot = styled.div `
  ${({ align, as, editorial, editorialBar, size, theme }) => {
    const baseSize = size ? size : AS_RULES[as];
    const { fontWeight, fontSize, marginBottom } = SIZES_RULES[baseSize];
    const breakpoints = [];
    Object.entries(theme.breakpoints).forEach(([key, value]) => {
        if (typeof value !== 'function') {
            const breakpointDist = breakPointDistance('2xl', key);
            const baseSizeIndex = UI_SIZES.indexOf(baseSize);
            const adjustIndex = baseSizeIndex + breakpointDist - 1;
            const adjustSize = UI_SIZES[adjustIndex];
            // We add a default value just in case the adjustSize is out of bounds
            const breakPointCSS = SIZES_RULES[adjustSize] || SIZES_RULES['xs'];
            const cssRules = css `
          font-size: ${breakPointCSS.fontSize};
          font-weight: ${breakPointCSS.fontWeight};
          margin-bottom: ${breakPointCSS.marginBottom};
        `;
            const breakpoint = theme.breakpoints.max({
                breakpoint: key,
                rules: cssRules,
                theme
            });
            breakpoints.push(breakpoint);
        }
    });
    const editorialCSS = !editorial || editorialBar === 'none' || as === 'h5' || as === 'h6'
        ? ''
        : css `
            position: relative;

            &::before {
              background-color: ${EDITORIAL_RULES[as]
            .color};
              content: '';
              height: ${EDITORIAL_RULES[as].height}px;
              position: absolute;
              top: calc(${getSpace('m')} * -1);
              width: ${EDITORIAL_RULES[as].width}px;

              ${editorialBar === 'center' && `left: 50%;`}
              ${editorialBar === 'center' && `transform: translateX(-50%);`}

              ${editorialBar === 'right' && `right: 0`}
            }
          `;
    return css `
      /* Common rules. */
      font-family: ${editorial
        ? theme.typography.fontEditorial
        : theme.typography.fontFamily};
      text-align: ${align};

      /* Theme */
      font-size: ${fontSize};
      font-weight: ${fontWeight};
      margin-bottom: ${marginBottom};
      margin-top: 0;

      /* Editorial */
      ${editorialCSS}

      /* Media Queries */
      ${breakpoints.reverse()}

      .wrapper {
        ${align === 'center' &&
        `
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: baseline;
          gap: 1rem;
        `}

        position: relative;

        > span {
          position: relative;
        }
      }

      .anchor {
        display: none;
        text-decoration: none;
        font-size: 1.25rem;
        top: 50%;
        margin-top: -0.75rem;

        ${(align === 'left' || align === 'inherit' || align === 'center') &&
        `
          position: absolute;
          left: -1.75rem;
          padding-right: 0.5rem;
        `}

        ${align === 'right' &&
        `
          position: absolute;
          right: -1.75rem;
          padding-left: 0.5rem;
        `}
      }

      &:hover .anchor {
        display: inline-block;
        visibility: visible;
      }
    `;
}}
`;
//# sourceMappingURL=Header.styled.js.map